import axios from 'axios';
import authHeader from './auth-header';
import CommonServices from './common-services'
// const API_URL = 'http://localhost:8080/api/test/';
const API_URL = CommonServices.extend_url() /*'http://local.hyvaaftersell.care/api/';*/
/* const API_URL = 'https://v1qa-hyva.aftersell.care/api/';*/

class UserService {
  getPublicContent() {
    return axios.get(API_URL + 'all');
  }

  getUserBoard() {
    return axios.get(API_URL + 'user', { headers: authHeader() });
  }

  getModeratorBoard() {
    return axios.get(API_URL + 'mod', { headers: authHeader() });
  }

  getAdminBoard() {
    return axios.get(API_URL + 'admin', { headers: authHeader() });
  }

  postMetod(remote_url,data){
    return  axios.post(API_URL+''+remote_url,data,{ headers: authHeader() });
  }
  getMetod(remote_url,data){
    return  axios.get(API_URL+''+remote_url, {params:data,headers: authHeader() });
  }

}

export default new UserService();
